import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import AssignQuotePopupNewCustomerInput from "./assignQuotePopupNewCustomerInput";
import AssignQuotePopupNewCustomerSelect from "./assignQuotePopupNewCustomerSelect";
import {HOW_DID_YOU_HEAR_ABOUT_US_OPTIONS, PREFERRED_COMMUNICATION_METHODS} from "./assignQuoteConstants";
import AssignPopupContext from './assignPopupContext';
import LookUserPhoneInput from "../../look/user/lookUserPhoneInput";
import LoadingSpinner from "../../ui/loadingSpinner";
import {getSelectedContracts} from "../contractSign/contractsFunctions";
import Misc from "../../../misc/misc";

const getSelectFields = (fabricatorData, contractsList) => {
  const selectFields = {
    "preferredCommunicationMethod": {
      placeholder: "assignPopup.newCustomer.placeholders.preferedCommunicationMethod",
      options: PREFERRED_COMMUNICATION_METHODS
    },
  }
  if (fabricatorData.isCaesarStone) {
    return (fabricatorData.settings.currency === "USD") ? {} : selectFields
  }
  if (fabricatorData.settings.useContractSigning && (contractsList.length > 1)) {
     return selectFields
  }
  selectFields["howDidYouHearAboutUs"] = {
    placeholder: "assignPopup.newCustomer.placeholders.howQuestion",
    options: HOW_DID_YOU_HEAR_ABOUT_US_OPTIONS
  }
  return selectFields
}

const getSelectedContractString = (fabricatorData, contractsList) => {
  if (!fabricatorData.settings.useContractSigning || (contractsList.length <= 1)) { // if only one - we are hiding block
    return ""
  }
  let selectedContracts = getSelectedContracts(contractsList);
  if (fabricatorData.isAmericanStandard) {
    selectedContracts = selectedContracts.filter((cont, contIndex) => contIndex !== 0);
  }
  if (!selectedContracts.length) {
    return ""
  }
  if (selectedContracts.length === 1) {
    return Misc.textSubStringEllipsis(selectedContracts[0].name, 36) || "Noname contract";
  } else {
    return selectedContracts.length + " Contracts Selected";
  }
}

const AssignQuotePopupNewCustomer = (props) => {

  const {isActive, fabricatorData, switchToContract, contractsList, contractsReceived} = props;
  const inputFields = {
    "firstName": "assignPopup.newCustomer.placeholders.firstName",
    "lastName":  "assignPopup.newCustomer.placeholders.lastName",
    "phoneNumber": "assignPopup.newCustomer.placeholders.phoneNumber1",
    "phone2":    "assignPopup.newCustomer.placeholders.phoneNumber2",
    "address1":  "assignPopup.newCustomer.placeholders.address1",
    "city":     fabricatorData.isCaesarStone ? "assignPopup.newCustomer.placeholders.address2" : "assignPopup.newCustomer.placeholders.city",
    "state":    "assignPopup.newCustomer.placeholders.state",
    "postal":    fabricatorData.isLowes ? "assignPopup.newCustomer.placeholders.postalLowes" : "assignPopup.newCustomer.placeholders.postal",
    "email":     "assignPopup.newCustomer.placeholders.email",
  };
  if (!fabricatorData.isCaesarStone) {
    delete inputFields["state"];
  }
  const selectFields = getSelectFields(fabricatorData, contractsList);
  let activeContractName = getSelectedContractString(fabricatorData, contractsList);

  return (
    <div className={"ass ass--new" + (isActive ? " ass--active" : "")}>
      <div className="ass-fields">
        {Object.keys(inputFields).map((property, propertyIndex) => {
          return (
            <AssignPopupContext.Consumer key={propertyIndex}>
              {/*{({context, setContext}) => (*/}
              {({inputsValidated}) => (property === "phoneNumber") ? (
                <LookUserPhoneInput
                  isActive={isActive}
                  inputsValidated={inputsValidated}
                  property={property}
                  placeholder={inputFields[property]}
                />
              ) : (
                <AssignQuotePopupNewCustomerInput
                  isActive={isActive}
                  inputsValidated={inputsValidated}
                  property={property}
                  placeholder={inputFields[property]}
                />
              )}
            </AssignPopupContext.Consumer>
          )
        })}
        {Object.keys(selectFields).map((property, propertyIndex) => {
          return (
            <AssignQuotePopupNewCustomerSelect
              key={propertyIndex}
              property={property}
              select={selectFields[property]}
            />
          )
        })}
        {fabricatorData.settings.useContractSigning && (contractsList.length > 1) ? (
          <div className="ass-field flex flex--center flex--start flex--1">
            <button className="ui-button2 ui-button2--green margin-r-8" onClick={switchToContract}>Assign Contract
            </button>
              {!contractsReceived ? <LoadingSpinner size="40"/> : (
                <span className={"bold secondary flex flex--center height-100" + (activeContractName ? " blue" : " red")
                  + (activeContractName ? " text-left break-word" : "")}>
                  {activeContractName || "* Assigned Contract Required"}
                </span>
              )}
          </div>
        ) : null}
      </div>
    </div>
  )
};

AssignQuotePopupNewCustomer.propTypes = {
  isActive: PropTypes.bool.isRequired,
  switchToContract: PropTypes.func,
};

const mapStateToProps = (store) => {
  const {contractsList, contractsReceived} = store.contractSigningState;
  return {
    assignQuotePopupSearchText: store.assignQuoteState.assignQuotePopupSearchText,
    fabricatorData: store.fabricatorState,
    contractsList,
    contractsReceived,
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(AssignQuotePopupNewCustomer)

